module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro3-old.e00cac61.mp3";